<template>
  <!-- Add Recurring Tip -->
  <v-dialog v-if="showDialog" v-model="showDialog" max-width="500px" persistent>
    <v-card class="pa-4">
      <v-card-title>
        <h2 class="title">
          <span v-if="action === 'set'">Set</span>
          <span v-if="action === 'change'">Change</span>
          Client for Gift Certificate</h2>
        <h2 v-if="!no_data.includes(item) && !no_data.includes(item.reference_number)" class="body-1">{{ `Reference Number: ${item.reference_number}` }}</h2>
      </v-card-title>
      <v-card-text class="mt-4">
        <v-flex class="px-2">
          <v-autocomplete
            :items="clients"
            v-model="preparedData.client_id"
            label="Client"
            item-text="full_name"
            item-value="id"
            placeholder="Please Select"
            :required="true"
            :loading="loadingClients"
            :error-messages="errors($v.preparedData.client_id) || server_errors.client_id"
            @focus="resetServerValidation"
            @blur="$v.preparedData.client_id.$touch()"
          ></v-autocomplete>
        </v-flex>
        <v-alert 
          class="pa-2 mt-4"
          :value="$v.$error"
          outlined
          color="error"
          icon="priority_high"
          transition="scale-transition"
        >
          <span class="caption">Please fill out form correctly.</span>    
        </v-alert>
        <v-alert
          class="pa-2 mt-4"
          :value="!serverValidation"
          outlined
          color="error"
          icon="priority_high"
          transition="scale-transition"
        >
          <span class="caption">{{ serverValidationMessage }}</span>
        </v-alert>
      </v-card-text>
      <!-- Footer Dialog -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeModal">Cancel</v-btn>
        <v-btn
          color="primary"
          :disabled="saveLoading"
          :loading="saveLoading"
          @click="addCoupon"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiService from "@/common/api.service";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { valMessages, getValMessage } from "@/common/error-messages"
import { mapActions } from 'vuex';

const validations = {
  preparedData: {
    client_id: { required }
  }
}

export default {
  name: "SetClientForGiftCard",
  mixins: [validationMixin],
  validations,
  data: () => ({
    no_data: [null, "", undefined, "null"],
    showDialog: false,
    item: null,
    action: 'set',
    clients: [],
    loadingClients: false,
    preparedData: {},
    saveLoading: false,
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong...",
    server_errors: {},
    unsubscribe: null
  }),
  mounted() {
    this.unsubscribe = this.$store.subscribeAction(action => {
      if (action.type === 'vEmit' && action.payload.name === 'SetClientForGiftCard') {
          this.openModal(action.payload.data)
      }
    })
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  methods: {
    ...mapActions(['vEmit']),
    getClients() {
      this.loadingClients = true
      ApiService.get("/client/list", { statuses: ['active']})
        .then(response => {
          let data = response.data;
          this.clients = data.clients;
          this.loadingClients = false
        })
        .catch(error => {
          console.log(error);
          this.loadingClients = false
        });
    },
    openModal(item) {
      this.preparedData = {};
      this.getClients()
      this.resetServerValidation();
      this.$v.$reset()
      if (!this.no_data.includes(item) && !this.no_data.includes(item.id)) {
        this.item = _.cloneDeep(item)
        this.preparedData.gift_certificate_id = item.id
        if (!this.no_data.includes(item.action)) {
          this.action = item.action
        }
        if (!this.no_data.includes(item.client_id)) {
          this.preparedData.client_id = item.client_id
        }
      }
      this.saveLoading = false;
      this.showDialog = true;
    },
    addCoupon() {
      this.resetServerValidation()
      this.$v.preparedData.$touch()
      if(!this.$v.$invalid){
        let body = {
          client_id: this.preparedData.client_id,
        };
        this.saveLoading = true;
        ApiService.put(`/gift_cards/${this.preparedData.gift_certificate_id}/update`, body)
          .then(response => {
            this.saveLoading = false;
            this.vEmit({ name: "notification", 
              data: {
                status: "success",
                text: `Client has been successfully ${this.action === 'change' ? 'changed' : 'set'}.`
              }
            });
            this.closeModal();
            this.$emit("done");
          })
          .catch(({ response }) => {
            this.saveLoading = false;
            this.serverValidation = false;
            if (response.data.error) {
              this.serverValidationMessage = this.titleCase(response.data.error);
            }
            if(response.data.message){
              this.serverValidationMessage = response.data.message
            }
            if (response.data.errors) {
              if (typeof response.data.errors === 'string') {
                  this.serverValidationMessage = response.data.errors
              } else {
                  this.server_errors = response.data.errors
              }
            }
          });
      }
    },
    closeModal() {
      this.showDialog = false;
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    },
    resetServerValidation() {
      this.serverValidation = true
      this.serverValidationMessage = "Oops something went wrong..."
      this.server_errors = {}
    },
    errors: getValMessage(valMessages)(validations)
  }
};
</script>
